<template>
  <div>
    <a-radio-group v-model:value="innerValue" :disabled="disabled" @change="onChange">
      <a-radio value="1">{{ trueText }}</a-radio>
      <a-radio value="0">{{ falseText }}</a-radio>
    </a-radio-group>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

/**
 * 使用方式:
 * <boolean-radio-group v-model="formRef.enable"></boolean-radio-group>
 */
export default defineComponent({
  isGlobal: true,
  name: "BooleanRadioGroup",
  props: {
    value: { type: Boolean, default: undefined },

    placeholder: { type: String, default: "请选择" },

    disabled: { type: Boolean, default: false },

    trueText: { type: String, default: "启用" },

    falseText: { type: String, default: "停用" },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const innerValue = ref<string | undefined>(undefined);

    const onChange = (evt) => {
      emit("update:value", evt.target.value === "1");
    };

    watch(
      () => props.value,
      (value) => {
        if (value === undefined) {
          innerValue.value = value;
        } else {
          innerValue.value = value ? "1" : "0";
        }
      },
      { immediate: true }
    );

    return {
      innerValue,
      onChange,
    };
  },
});
</script>
